<div class="flex flex-row lt-lg:flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
  <div class="full-width flex-[65%] max-w-[65%] lt-lg:flex-[100%] lt-lg:max-w-[100%]">
    <app-feature-list-container
      ><div class="commissioning-subtitle">
        {{ '+GATEWAY_COMMISSIONING_REDESIGN.ONE_BASE_INSTRUCTIONS_TITLE' | translate }}
      </div>
      <mat-radio-group
        class="flex flex-col gap-[18px] justify-start items-start"
        [(ngModel)]="selectedEntryPoint"
      >
        <mat-radio-button *ngFor="let entryPoint of availableEntryPoints" [value]="entryPoint">
          {{ entryPoint.translatedName }}
        </mat-radio-button>
      </mat-radio-group>
    </app-feature-list-container>
    <app-feature-list-container *ngIf="selectedEntryPoint">
      <div class="instructions flex-1">
        <div
          *ngFor="let instruction of selectedEntryPoint.instructions; let i = index"
          class="instruction-option"
        >
          <div class="order">{{ i + 1 }}</div>
          <div>{{ instruction }}</div>
        </div>
      </div>
    </app-feature-list-container>
  </div>

  <div class="steps-wrapper flex flex-col gap-[24px] xs:gap-[16px] flex-1">
    <div class="flex flex-col md:flex-row gap-[24px] xs:gap-[16px]">
      <app-edit-commissioning-step
        class="flex-1"
        [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.TITLE'"
        [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.COMPLETED'"
        [showEditButton]="true"
        [displayConfirmDialog]="true"
        (previousStep)="previousStepClicked()"
      ></app-edit-commissioning-step>
      <app-edit-commissioning-step
        class="flex-1"
        [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_TRANSFER_INSTALLATION.TITLE'"
        [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP.CONTINUE_LAST_STEP'"
      ></app-edit-commissioning-step>
    </div>
    <button
      class="next-step-btn flex-1"
      gtm="onNextStep"
      gtmCategory="gatewayCommissioningGwNetwork"
      mat-raised-button
      data-at-next-button
      color="primary"
      (click)="nextStepClicked()"
    >
      <span>{{ 'GENERAL.BUTTON.NEXT_STEP' | translate }}</span>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
